import React from "react";
import ReactDOM from "react-dom/client";

// Static HTML landing page - React not needed
// All content is in /public/index.html for instant loading
const root = document.getElementById("root");
if (root) {
  // Only render React if the root div is empty (dev mode)
  // In production, static HTML is served directly
  if (root.innerHTML.trim() === '') {
    const App = React.lazy(() => import("@/App"));
    ReactDOM.createRoot(root).render(
      <React.StrictMode>
        <React.Suspense fallback={null}>
          <App />
        </React.Suspense>
      </React.StrictMode>
    );
  }
}

